import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from "rxjs/operators";
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { AsyncService } from '../async/async.service';
import { DaoService } from './dao.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class DaoErrorInterceptor implements HttpInterceptor {

  constructor(
    private oidcSecurityService: OidcSecurityService,
    private async: AsyncService,
    private dao: DaoService) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          let errorMsg = '';
          if (error.status === 403) {
            this
              .async
              .openDialog("Warning", "Your license expired.", (answer) => {
                window.location.href = environment.shopLink;
              })
          }
          return throwError(errorMsg);
        })
      )
  }
}
